"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TargetGradesServiceClient = void 0;
var TargetGradesServiceClient_1 = require("./TargetGradesServiceClient");
Object.defineProperty(exports, "TargetGradesServiceClient", { enumerable: true, get: function () { return __importDefault(TargetGradesServiceClient_1).default; } });
//# sourceMappingURL=index.js.map